"use client"
import React, { useEffect, useState } from "react"

type Props = {
   post: any
}

const JumpLinks = ({ post }: Props) => {
   const [activeIndex, setActiveIndex] = useState<number | null>(null)

   useEffect(() => {
      const handleScroll = () => {
         const ids = post?.article_body?.content?.paragraphs.map((_: any, i: number) => i.toString())
         if (!ids) return

         const center = window.innerHeight / 2
         let closestIdx = 0
         let minDist = Infinity

         ids.forEach((id: string, idx: number) => {
            const el = document.getElementById(id)
            if (el) {
               const rect = el.getBoundingClientRect()
               const elCenter = rect.top + rect.height / 2
               const dist = Math.abs(center - elCenter)
               if (dist < minDist) {
                  minDist = dist
                  closestIdx = idx
               }
            }
         })
         setActiveIndex(closestIdx)
      }

      window.addEventListener("scroll", handleScroll, { passive: true })
      handleScroll() // Initial check

      return () => window.removeEventListener("scroll", handleScroll)
   }, [post])

   return (
      <div className="sticky top-32 hidden h-fit min-w-[14rem] lg:block">
         <h3 className="text-custom-3xl-bold text-title ">Table of Contents</h3>
         <div className="mb-6 mt-2 h-1 w-1/6 bg-custom-primary" />
         <div className="rounded-xl border border-resources-bg  shadow-sm">
            <nav aria-label="Jump links">
               <ul className="flex flex-col  divide-y divide-separation-line">
                  {post?.article_body?.content?.paragraphs.map((paragraph: any, i: number) => (
                     <li key={i} className="line-clamp-1 block  w-full ">
                        <a
                           href={`#${i}`}
                           onClick={(e) => {
                              e.preventDefault()
                              const el = document.getElementById(i.toString())
                              if (el) {
                                 el.scrollIntoView({ behavior: "smooth", block: "start" })
                              }
                           }}
                           className={`block w-full px-5 py-3 font-lora text-custom-base-bold transition-all duration-200 ${
                              activeIndex === i
                                 ? " bg-custom-primary/30 text-title"
                                 : "text-title hover:bg-custom-primary/30"
                           }`}
                        >
                           <span className="block w-full truncate">{paragraph.jump_link}</span>
                        </a>
                     </li>
                  ))}
               </ul>
            </nav>
         </div>
      </div>
   )
}

export default JumpLinks
